import PropTypes from 'prop-types';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { SIN_VALOR, nombreAlumno, nombreEvaluador } from '../../features/notasD2l';
import colors from '../../theme/colors';

const terminoStyle = {
  fontSize: '0.75rem',
  fontWeight: 600,
  color: colors.textSecondary,
  margin: 0,
};

const definicionStyle = {
  margin: '2px 0 0',
  color: colors.text,
  fontSize: '0.875rem',
  overflowWrap: 'anywhere',
};

const notaD2lShape = PropTypes.shape({
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  usuario: PropTypes.string,
  nombre: PropTypes.string,
  apellido: PropTypes.string,
  codigo_oferta: PropTypes.string,
  nombre_oferta: PropTypes.string,
  categoria_elemento: PropTypes.string,
  nombre_elemento: PropTypes.string,
  ponderacion: PropTypes.number,
  numerador_puntos: PropTypes.number,
  denominador_puntos: PropTypes.number,
  valor_calificacion: PropTypes.string,
  ultima_modificacion: PropTypes.string,
  comentarios: PropTypes.string,
  usuario_evaluador: PropTypes.string,
  evaluador: PropTypes.string,
  nombre_evaluador: PropTypes.string,
  apellido_evaluador: PropTypes.string,
});

const ModalComentarioNotaD2l = ({ isOpen, fila = null, onCerrar, onClosed }) => {
  const contexto = [
    { termino: 'Alumno', valor: nombreAlumno(fila) },
    { termino: 'Elemento', valor: fila?.nombre_elemento },
    { termino: 'Evaluador', valor: nombreEvaluador(fila) },
    { termino: 'Fecha', valor: fila?.ultima_modificacion },
  ];

  return (
    <Modal isOpen={isOpen} toggle={onCerrar} onClosed={onClosed} centered scrollable>
      <ModalHeader toggle={onCerrar}>Comentario</ModalHeader>
      <ModalBody>
        <dl
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
            gap: '12px 16px',
            margin: '0 0 16px',
          }}
        >
          {contexto.map(({ termino, valor }) => (
            <div key={termino}>
              <dt style={terminoStyle}>{termino}</dt>
              <dd style={definicionStyle}>{valor || SIN_VALOR}</dd>
            </div>
          ))}
        </dl>
        {/* Texto plano a propósito: el comentario puede traer HTML de D2L y no se interpreta. */}
        <div
          style={{
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word',
            padding: '12px 14px',
            borderRadius: '8px',
            border: `1px solid ${colors.border}`,
            background: colors.bg,
            color: colors.text,
            fontSize: '0.875rem',
            lineHeight: 1.5,
          }}
        >
          {fila?.comentarios || ''}
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={onCerrar}>
          Cerrar
        </Button>
      </ModalFooter>
    </Modal>
  );
};

ModalComentarioNotaD2l.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  fila: notaD2lShape,
  onCerrar: PropTypes.func.isRequired,
  onClosed: PropTypes.func,
};

export default ModalComentarioNotaD2l;
